export default {"src":"/_next/static/media/instagram_icon_black.3a93cf3e.svg","height":56,"width":56};